/**
 * Plan-feature keys — mirror of the BE FeatureKey enum.
 *
 * Scope: NoticeAI direct subscribers only. Partner-deployment-only
 * capabilities (webhook delivery, API tokens, white label, etc.) are
 * managed elsewhere and intentionally absent from this list.
 *
 * Used by:
 *   - hooks/usePlanFeatures.js to look up the current org's capability map
 *   - any component that gates UI on a plan feature
 *
 * Keep this file in sync with backend/app/utils/plan_features.py
 * FeatureKey enum. When the BE adds a new feature, add the same string
 * here. Stale keys will quietly resolve to `false` because the BE
 * endpoint includes every registered key in its response.
 */
export const FEATURE_KEYS = {
  AI_RESPONSE_GENERATION: "AI_RESPONSE_GENERATION",
  LEGAL_RESPONSE_GENERATION: "LEGAL_RESPONSE_GENERATION",
  COMPREHENSIVE_ANALYSIS: "COMPREHENSIVE_ANALYSIS",
  CASE_DETAILS_FETCH: "CASE_DETAILS_FETCH",
  VIEW_NOTICE_SUMMARY: "VIEW_NOTICE_SUMMARY",
  BULK_EXPORT: "BULK_EXPORT",
  MULTI_USER_SUPPORT: "MULTI_USER_SUPPORT",
  GST_APPEAL_DRAFTING: "GST_APPEAL_DRAFTING",
  IT_APPEAL_DRAFTING: "IT_APPEAL_DRAFTING",
};

// All keys as an array — useful for matrix rendering in the admin page.
export const ALL_FEATURE_KEYS = Object.values(FEATURE_KEYS);
